import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
    CreateEnrolementInput,
    IEnrolement,
    IInvoices,
    IUploadInvoice,
    IUploadTaxForms,
    IUploadNDAForm,
    IUploadVoidCheque,
    ITaxFormsUploadResponse,
    INDAFormUploadResponse,
    IVoidChequeUploadResponse
} from './enrole.interface';

const API_URI = `${environment.apiBaseUrl}/enrollment-form`;
const INVOICE_API_URI = `${environment.apiBaseUrl}/invoice`;
const USER_API_URI = `${environment.apiBaseUrl}/user`;

@Injectable({ providedIn: 'root' })
export class EnrolementService {
    http: HttpClient = inject(HttpClient);

    getAllEnrolements() {
        return this.http.get<IEnrolement[]>(API_URI);
    }

    createEnrolement(input: CreateEnrolementInput) {
        return this.http.post<IEnrolement>(`${API_URI}`, input);
    }

    getUserEnrolement(userId: string) {
        return this.http.get<IEnrolement>(`${API_URI}/${userId}`);
    }
    getSingleEnrolement(id: string) {
        return this.http.get<IEnrolement>(`${API_URI}/single/${id}`);
    }

    getAllInvoices() {
        return this.http.get<IInvoices[]>(INVOICE_API_URI + '/all');
    }

    uploadeInvoice(input: { employeeName: string; invoicesBase64: string[] }) {
        return this.http.post<string[]>(`${INVOICE_API_URI}/upload-invoice`, input);
    }

    submitInvoice(input: IUploadInvoice) {
        return this.http.post<IInvoices>(`${INVOICE_API_URI}`, input);
    }

    getSingleInvoice(id: string) {
        return this.http.get<IInvoices>(`${INVOICE_API_URI}/single/${id}`);
    }

    uploadTaxForms(input: IUploadTaxForms) {
        return this.http.post<ITaxFormsUploadResponse>(`${API_URI}/upload-tax-forms`, input);
    }

    uploadNDAForm(input: IUploadNDAForm) {
        return this.http.post<INDAFormUploadResponse>(`${API_URI}/upload-nda-form`, input);
    }

    uploadVoidCheque(input: IUploadVoidCheque) {
        return this.http.post<IVoidChequeUploadResponse>(`${API_URI}/upload-void-cheque`, input);
    }

    downloadTaxForms(userId: string, s3path?: string) {
        return this.http.post(
            `${API_URI}/download-tax-forms`,
            { userId, s3path },
            {
                responseType: 'blob',
                observe: 'response'
            }
        );
    }

    downloadNDAForm(userId: string) {
        return this.http.get(`${API_URI}/download-nda-form/${userId}`, {
            responseType: 'blob',
            observe: 'response'
        });
    }

    downloadVoidCheque(userId: string) {
        return this.http.get(`${API_URI}/download-void-cheque/${userId}`, {
            responseType: 'blob',
            observe: 'response'
        });
    }

    getUserById(userId: string) {
        return this.http.get(`${USER_API_URI}/single/${userId}`);
    }
}
